import styled from "styled-components";
import { MainWrapper } from "@/lib/styles";

export const Container = styled(MainWrapper)`
  position: sticky;
  top: ${({ theme }) => theme.space.headerMinHeight};
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 4;
  padding-bottom: 1.5rem;
`;

export const Inner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.animation-enter {
    opacity: 0;
  }
  &.animation-exit {
    opacity: 1;
  }
  &.animation-enter-active {
    opacity: 1;
  }
  &.animation-exit-active {
    opacity: 0;
  }
  &.animation-enter-active,
  &.animation-exit-active {
    transition: opacity 100ms;
  }
`;
